module.exports = __webpack_public_path__ + "img/landing-screen-2.c07dcaad.jpg";